import { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_LABELS, SUPPORTED_LANGUAGES, type Language } from '@/i18n';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const current = (i18n.resolvedLanguage ?? 'de') as Language;

  const choose = (lng: Language) => {
    void i18n.changeLanguage(lng);
    setAnchor(null);
  };

  return (
    <>
      <Tooltip title={t('common.language')}>
        <IconButton
          onClick={(e) => setAnchor(e.currentTarget)}
          aria-label={t('common.language')}
          aria-haspopup="menu"
          size="small"
        >
          <TranslateIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {SUPPORTED_LANGUAGES.map((lng) => (
          <MenuItem key={lng} selected={lng === current} onClick={() => choose(lng)}>
            {LANGUAGE_LABELS[lng]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
